<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
<userLeft :active="7" />
      <div class="box5" style="position: relative;">
        <div style="overflow: hidden;">
          <div class="box6" style="float: left;">消息通知</div>
        <!-- <router-link to="/add_feedback"><div class="box14">+提交反馈</div></router-link> -->
        </div>
        <div class="box7"></div>

        <div class="box12">
<!--                                                    -->
          <div class="box13" style="padding-left: 10px; line-height: 40px;">通知时间</div>
          <div class="box41" style="display:flex;justify-content: space-between;">
            <div style="line-height: 40px;">通知详情</div>
            <div style="line-height: 40px;margin-right:20px">查看</div>
          </div>
          <div class="box13" style="text-align: right;line-height: 40px;">

            <a-select default-value="全部" style="width: 120px;text-align: right;line-height: 40px;" @change="handleChange">
              <a-select-option value="全部">
                全部
              </a-select-option>
              <a-select-option value="未读">
                未读
              </a-select-option>
              <a-select-option value="已读">
                已读
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div  class="box12" style="margin-top: 0; background: none; border-bottom: 1px solid #EEEEEE; height: 60px;" :key="index" v-for="(item,index) in list">
          <div class="box13" style="padding-left: 10px;">
            {{ item.createdAt }}
          </div>
          <div class="box41" style="display:flex;justify-content: space-between;">
            <span class="zhehang">
                {{ item.message }}
            </span>
            <span @click="chakanxiaoxi(item)" style="color: #2B9A34;cursor: pointer;" v-if="item.switchJump==1">点击查看</span>
          </div>
          <div class="box13" style="text-align: right;">
              <span style="color: #999999;padding-right: 10px;position: relative;">
                <span style="margin-right: 5px;">{{item.read ? '已读' : '未读'}}</span>
              <div class="weiduhongdian" v-if="!item.read"></div>
              </span>
          </div>
        </div>
<div v-if="list.length == 0" style="margin-top: 40px; text-align: center;">没有记录~</div>
        <div style="position: absolute; bottom: 2%; width: 100%;display: flex;justify-content: center;align-items: center;">
          <a-pagination
            show-quick-jumper
            :default-current="1"
            :total="totalPages*10"
            @change="fanye"
          />
        </div>
      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";

export default {
        name: "integral",
          components: {
    userLeft,
        htmlHeader,
    foot,
  },
        data() {
            return {
              totalPages: 1,//总页数
              list: [], //消息数据
              page: 0,
              read: '全部',
            }
        },
        created() {
          this.getList()
        },
        methods: {
          // 去处理消息
          chakanxiaoxi(e) {
            // 标记已读
            this.api.read_message(e.uuid).then(res=>{

            })
            if(e.targetType == 'COMPLAINT') {
              // 投诉
              this.$router.push('/complaint_details?uuid=' + e.targetId)
            }else if(e.targetType == 'AFTER_SALE') {
              // 售后订单
              this.$router.push('/refund_details?uuid=' + e.targetId)
            }
          },
          // 翻页
          fanye(e) {
            this.page = e - 1
            this.getList()
          },
          // 切换未读已读
          handleChange(e) {
            this.read = e
            this.getList()
          },
          // 刷新列表
          getList() {
            let obj = {
              size: 10,
              page: this.page,
            }
            if(this.read == '已读') {
              obj.read = true
            }else if(this.read == '未读') {
              obj.read = false
            }
            this.api.get_user_system_message(obj)
              .then(res => {
                if(res.ok) {
                  this.list = [...res.data.content]
                  this.totalPages = res.data.totalPages
                }
              })
          },
        },
    };
</script>

<style scoped>
  .weiduhongdian {
    width: 6px;
height: 6px;
background: #FF0000;
border-radius: 50%;
position: absolute;
top: 0;
right: 0;
  }
.shangyiye {
  width: 100px;
height: 32px;
border: 1px solid #EDE9E9;
text-align: center;
line-height: 32px;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #999999;
float: left;
cursor: pointer;
}
.ant-select-selection {
  background: #F4F4F4 !important;
}
.zhehang{
  display: inline-block;
}
.box14 {
  width: 120px;
height: 32px;
border: 1px solid #2C9A34;
float: right;
text-align: center;
line-height: 32px;

font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #2C9A34;


}
  .box13 {
    width: 20%;
    height: 100%;
    float: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
  }
    .box41 {
    width: 60%;
    height: 100%;
    float: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
  }
  .box12 {
    width: 100%;
height: 40px;
background: #F4F4F4;
margin-top: 4%;

  }
    .box11 {
        width: 100px;
        height: 32px;
        border: 1px solid #2B9A34;
        margin: 8% auto;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
    }

    .box10 {
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF9629;
        /* line-height: 16px; */
        margin: 4% auto;
    }

    .box9 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin: auto;
    }

    .box8 {
        width: 100%;
        height: 105px;
        background: EEF7EF;
        /* opacity: 0.08; */
        padding-top: 4%;
    }

    .box7 {
        width: 100%;
        height: 1px;
        border-top: 1px solid #E8E6E6;
        margin-top: 2%;
    }

    .box6 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        /* margin-top: 2%; */
        text-align: left;
    }

.box5 {
        min-height: 1023px;
        width: 80%;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }

    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }

    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }

    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }
</style>



// WEBPACK FOOTER //
// src/components/message.vue